import { HomeView } from "~landing/views/home";
import { GetServerSideProps, NextPage } from "next";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { useEffect } from "react";
import { sendLandingPageViewEvent } from "~tag-manager/send-event";

const LandingPage: NextPage = () => {
	useEffect(() => {
		sendLandingPageViewEvent({ icp: "gis" });
	}, []);

	return (
		<>
			<MarketingSeo
				path=""
				title="Publish and share interactive maps instantly"
				description="MangoMap sits between your spatial data and the people who need to act on it. Your files come in as-is. Your stakeholders get a link, not a download."
			/>
			<HomeView />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async (context) => {
	console.info("[landing-page] getServerSideProps", {
		resolvedUrl: context.resolvedUrl,
		host: context.req.headers.host,
		xMangomapOriginalHost: context.req.headers["x-mangomap-original-host"],
		xForwardedHost: context.req.headers["x-forwarded-host"],
		secFetchDest: context.req.headers["sec-fetch-dest"],
		userAgent: context.req.headers["user-agent"],
	});

	return Promise.resolve({
		props: {},
	});
};

export default LandingPage;
